import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import {
    AuthenticationService,
    EspaceDocumentaireService,
    QuestionnaireSanteService,
    ReponseQuestionnaireSante,
    EspaceClientService,
    ReponseQuestionnaireSanteSimplifie
} from '@kv-common-components/kx-services';
import { collapse } from '@shared/animations/animations';
import { QuestionMotifComponent } from '@shared/components/qs-questions/question-motif/question-motif.component';
import { QuestionTailleComponent } from '@shared/components/qs-questions/question-taille/question-taille.component';
import { QuestionChapeauComponent } from '@shared/components/qs-questions/question-chapeau/question-chapeau.component';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { RouterHelperService } from '@shared/services/router-helper.service';
import { QsPreFedService } from '../questionnaire-de-sante-simplifie/qs-pre-fed.service';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-qs-component',
    animations: [collapse],
    templateUrl: './qs.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: [],
    providers: [QsPreFedService]
})
export class QsComponent implements OnInit, OnDestroy {
    @ViewChildren(QuestionMotifComponent)
    questionMotifComponents!: QueryList<QuestionMotifComponent>;
    @ViewChildren(QuestionTailleComponent)
    questionTailleComponents!: QueryList<QuestionTailleComponent>;
    @ViewChildren(QuestionChapeauComponent)
    questionChapeauComponents!: QueryList<QuestionChapeauComponent>;

    idPersonne: string;
    idDossier: string;
    idPropositionPrincipale: string;

    versionPapierCollapsed = true;
    listeQuestionsQuestionnaireSante: any[];
    listeQuestionsEntete: any[];
    qsForm: FormGroup;
    qsLoading = false;
    currentEspaceClient: any;
    isFromQSS = false;
    goBackToEspaceClientModal = false;
    preValidateQsModal = false;
    saveLoading = false;
    showSuccesModal = false;
    isSaveForNextAdhChecked = false;

    questionnaireSanteSubscription: Subscription;

    constructor(
        private questionnaireSanteService: QuestionnaireSanteService,
        private espaceDocumentaireService: EspaceDocumentaireService,
        private espaceClientService: EspaceClientService,
        private authenticationService: AuthenticationService,
        public routerHelper: RouterHelperService,
        private router: Router,
        private logger: NGXLogger,
        public i18nPipe: I18nPipe,
        public qsPreFedService: QsPreFedService,
        public changeDetectorRef: ChangeDetectorRef
    ) {
        this.qsLoading = true;
        this.idPersonne =
            this.authenticationService.currentUserValue.idPersonne.toString();
        this.idDossier =
            this.authenticationService.currentUserValue.idDossier.toString();
        this.idPropositionPrincipale =
            this.authenticationService.currentUserValue.idPropositionPrincipale;
        this.isFromQSS = this.routerHelper.isFromQSS;
    }
    initQsReponses() {
        let methodeEspaceClient = 'refreshEspaceClient';
        if (this.routerHelper.previousUrl === '') {
            methodeEspaceClient = 'getrefreshedEspaceClient';
        }
        this.espaceClientService[methodeEspaceClient](
            this.authenticationService.currentUserValue.idPersonne
        ).subscribe((data) => {
            const contextDossier =
                ContextDossier.initContextDossierFromEspaceClient(
                    this.idPersonne,
                    this.idDossier,
                    data
                );
            const listeReponsesQuestionsSante =
                contextDossier.emprunteur.assurance.listeReponsesQuestionsSante;
            if (
                listeReponsesQuestionsSante &&
                listeReponsesQuestionsSante.length > 0
            ) {
                this.qsPreFedService.setPreviousQsResponses(
                    listeReponsesQuestionsSante,
                    this.qsForm,
                    this.questionChapeauComponents,
                    this.questionMotifComponents
                );
            }
            this.qsLoading = false;
            this.changeDetectorRef.detectChanges();
        });
    }
    ngOnInit(): void {
        this.qsForm = new FormGroup({});
        this.questionnaireSanteService.initializeData(
            this.idPersonne,
            this.idDossier
        );
        this.questionnaireSanteSubscription =
            this.questionnaireSanteService.currentQuestionnaireSante
                .pipe(take(1))
                .subscribe((data) => {
                    this.listeQuestionsQuestionnaireSante =
                        data.listeQuestionsQuestionnaireSante;
                    this.listeQuestionsEntete = this.filtreQuestionEntete();
                    this.changeDetectorRef.detectChanges();
                    this.initQsReponses();
                });
    }

    ngOnDestroy() {
        if (this.questionnaireSanteSubscription) {
            this.questionnaireSanteSubscription.unsubscribe();
        }
    }

    filtreQuestionEntete() {
        return this.listeQuestionsQuestionnaireSante.filter(
            (question) => question.idQuestionChapeau === undefined
        );
    }
    preValidateQs(f: FormGroup) {
        if (f.valid) {
            this.preValidateQsModal = true;
        } else {
            this.setAllControlsAsDirty(f);
        }
    }
    validateQs(f: FormGroup) {
        this.logAllInvalidControls(f);
        if (f.valid) {
            this.qsLoading = true;
            const reponses: ReponseQuestionnaireSante[] = this.getReponses();

            if (this.isSaveForNextAdhChecked) {
                this.questionnaireSanteService
                    .saveForNextAdh(
                        this.idPersonne,
                        this.idDossier,
                        reponses,
                        null,
                        true
                    )
                    .subscribe((data) => {
                        this.logger.info(
                            'questionnaireSanteService.saveForNextAdh : Success'
                        );
                    });
            }
            this.questionnaireSanteService
                .postValidation(this.idPersonne, this.idDossier, reponses, true)
                .toPromise()
                .then((data) => {
                    this.logger.info(
                        'QuestionnaireSanteSimplifieService.postValidation response : ',
                        { data }
                    );

                    this.espaceClientService
                        .refreshEspaceClient(this.idPersonne)
                        .subscribe(() => {
                            this.espaceDocumentaireService
                                .getEspaceDocumentaire(
                                    this.idPersonne,
                                    this.idPropositionPrincipale
                                )
                                .subscribe(() => {
                                    this.qsLoading = false;
                                    this.routerHelper.navigateAfterQSS(data);
                                });
                        });
                });
        } else {
            this.setAllControlsAsDirty(f);
        }
    }

    saveQs() {
        this.saveLoading = true;

        if (this.isValidForSave()) {
            //On collecte toutes les reponses et les sous-reponses
            const reponses: ReponseQuestionnaireSante[] = this.getReponses();

            //On appelle le webservice KX d enregistrement des reponses du QS
            this.questionnaireSanteService
                .postEnregistrement(this.idPersonne, this.idDossier, reponses)
                .toPromise()
                .then(() => {
                    this.logger.info(
                        'QuestionnaireSanteService.postEnregistrement : Success'
                    );
                    this.saveLoading = false;
                    this.showSuccesModal = true;
                    this.changeDetectorRef.detectChanges();
                })
                .catch((reason) => {
                    this.logger.error(
                        'QuestionnaireSanteService.postEnregistrement : Failed',
                        reason
                    );
                });
        } else {
            this.saveLoading = false;
        }
    }

    isValidForSave() {
        let result = true;
        Object.keys(this.qsForm.controls).forEach((key) => {
            if (
                this.qsForm.controls[key].status === 'INVALID' &&
                key.match(/[abcde]-\d+/g)
            ) {
                result = false;
            }
        });
        return result;
    }

    navigateToEspaceClient() {
        this.router.navigateByUrl('espace-client/tableau-de-bord');
    }

    public setAllControlsAsDirty(f: FormGroup) {
        Object.keys(f.controls).forEach((key) => {
            f.controls[key].markAsDirty();
            f.controls[key].markAsTouched();
        });
    }

    private getReponses(): ReponseQuestionnaireSanteSimplifie[] {
        const reponses: ReponseQuestionnaireSanteSimplifie[] = [];
        this.questionTailleComponents.forEach((questionTailleComponent) => {
            reponses.push(questionTailleComponent.getReponse());
        });
        this.questionMotifComponents.forEach((questionMotifComponent) => {
            reponses.push(questionMotifComponent.getReponse());
        });

        this.questionChapeauComponents.forEach((questionChapeauComponent) => {
            Array.prototype.push.apply(
                reponses,
                questionChapeauComponent.getReponse()
            );
        });

        //On trie les reponses selon leur id
        reponses.sort((r1, r2) => Number(r1.id) - Number(r2.id));
        return reponses;
    }

    private logAllInvalidControls(f: FormGroup) {
        const controls = f.controls;
        Object.keys(controls).forEach((key) => {
            this.logger.debug(controls[key].status, ' : ', key);
        });
    }
}
